import React from "react";
import { useRequest } from "../../hooks/useRequest";
import styled from "styled-components";
import { MdOutlineDelete } from "react-icons/md";
import { toast } from "react-toastify";
import { useAppContext } from "../../context/useAppContext";

const ClearCartStyle = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: #ae0000;
  cursor: pointer;
  .icon {
    font-size: 14px;
  }
  &:hover {
    text-decoration: underline;
  }
`;

const ClearCartButton = ({ title = "Clear cart", cartId, setIsCleared, setCartData, onCartCleared }) => {
  const [handleClearRequest] = useRequest();
  const { setCartItemNumber } = useAppContext();

  const handleClearCart = async (cartId) => {
    try {
      const path = `/cart/${cartId}/clear-cart`;
      const response = await handleClearRequest({ path, method: "DELETE" });

      if (!response.success) {
        return toast.error(response.message);
      }

      // Clear local cart data immediately
      setCartData && setCartData(prev => ({
        ...prev,
        items: []
      }));

      // Reset cart item number in global context
      setCartItemNumber(0);

      // Trigger parent component refresh
      setIsCleared && setIsCleared((prev) => !prev);

      // Call the onCartCleared callback to handle cart switching
      onCartCleared && onCartCleared(cartId);

      toast.success(response.message);
    } catch (error) {
      toast.error("Failed to clear cart. Please try again.");
    }
  };

  return (
    <ClearCartStyle
      className="clear__cart"
      onClick={() => handleClearCart(cartId)}
    >
      <MdOutlineDelete className="icon" />
      {title}
    </ClearCartStyle>
  );
};

export default ClearCartButton;
